/* eslint react/no-direct-mutation-state: "off",'array-callback-return': 'off','no-redeclare': 'off', eqeqeq: 'off',no-useless-escape: 'off', no-useless-concat: 'off', no-unused-vars: 'off' */
import React, { Component } from "react";
import { Table,Label,Button,Modal } from "reactstrap";
import { connect } from "react-redux";
import {createFilter} from "react-search-input";
import classnames from 'classnames';
import '../../../Assets/EnsembleStyles/WorkOrders.css';
import { GetPreventativeMaintenanceList,GetEquipmentPreventativeMaintenanceList, GetClosedPreventativeMaintenanceList, DeletePreventativeMaintenance } from "../../../action/workorderAction";
import PMDetails from './_ModalsForms/PreventativeMaintenanceDetails';
import ProgressBar from 'react-bootstrap/ProgressBar';
import ReactPaginate from 'react-paginate';
import { FaPrint } from 'react-icons/fa';
import TraneLogo from '../../../Assets/icons/Icons__trane-logo.svg';
import TraneTechLogo from '../../../Assets/icons/tt_logo_tm_color_rgb.png';
import LoadingIndicator from '../Common/LoadingIndicator';
import ErrorGif from '../../../Assets/images/Error.gif';
import { Icon } from 'semantic-ui-react';
import DeleteConfirmation from './_ModalsForms/WorkOrderDeleteConfirmation';
import * as ErrorMessage from '../../../Resources/ErrorMessages';
import SelectAllCheckboxes from '../../../Resources/SelectAllCheckboxes';

const KEYS_TO_FILTERS = ['serialNumber','title','buildingName','equipment','due','technicianName','statusName'];
let pagesCount = 0, PrintPaginationText = '';
class PreventativeMaintenanceList extends Component {
    componentWillMount(){
        var FilterDetails = sessionStorage.getItem('PMFilterDetails');
        if (FilterDetails !== undefined && FilterDetails !== null && FilterDetails !== "null") {
            var lFilterDetails = JSON.parse(FilterDetails);
            if(lFilterDetails.filtervalue === "7"){
                this.props.GetClosedPreventativeMaintenanceList();
            }
            this.setState({ FilterValue: lFilterDetails.filtervalue, IsClosedStatus: lFilterDetails.isclosedstatus, currentPage: 0 });
        }
        if(this.props.ForEquipment)
            this.props.GetEquipmentPreventativeMaintenanceList(this.props.EquipmentSummaryId).then(() => {this.setState({isloading:false})});
        else{
            this.props.GetPreventativeMaintenanceList().then(() => {
                this.setState({isloading:false});
                var MailDetails = localStorage.getItem('mailPMId');
                if (MailDetails !== undefined && MailDetails !== null && MailDetails !== "null" && MailDetails !== "") {
                    let data = this.props.getPMList.PreventativeMaintenanceList;
                    if (data !== undefined && data !== null && data.length > 0) {
                        let data1 = data.filter(x => x.id == MailDetails);
                        if (data1 !== undefined && data1 !== null && data1.length > 0) {
                            this.setState({PMId: MailDetails, redirect: true});
                            localStorage.setItem("mailPMId", null);
                        }
                    }
                }
            });   
        }   
        //this.props.GetWorkOrderBuildings();
       // this.props.GetWorkorderTechnician();
       // this.props.GetWorkOrderBuildingsEquipments(0);
        var el = document.getElementsByClassName('Ensemble_Content_FullPage'); 
        if(el[0] !== undefined)
            el[0].scrollIntoView();
    }

    constructor(props) {
        super(props);
        this.state = {
            isloading: true,
            IsError: false,
            currentPage: 0,
            pageSize: 50,
            FilterValue:"1", 
            sort: {
                column: null,
                direction: [
                    { name: 'id', direction: 'desc', onclick: false },
                    { name: 'name', direction: 'desc', onclick: false },
                    { name: 'buildingName', direction: 'desc', onclick: false },
                    { name: 'equipmentName', direction: 'desc', onclick: false },
                    { name: 'dueDate', direction: 'desc', onclick: true },
                    { name: 'assignedTo', direction: 'desc', onclick: false },
                    { name: 'status', direction: 'desc', onclick: false },
                ]
            },
            searchTerm: "",
            IsDefaultSort: true,
            IsClosedStatus: false,
            redirect: false,
            PMId: 0,
            statusId: 0,
            error_msg: false,
            deletemodal: false,
        };
        this.onSortNumber = this.onSortNumber.bind(this);
        this.onSort = this.onSort.bind(this);
        this.onSortDate = this.onSortDate.bind(this);
        this.searchUpdated = this.searchUpdated.bind(this);
        this.OnFilterChange = this.OnFilterChange.bind(this);
        this.handlePageClick = this.handlePageClick.bind(this);
        this.UpdateRedirection = this.UpdateRedirection.bind(this);
        this.OpenPrintPreview = this.OpenPrintPreview.bind(this);
    }

    componentWillReceiveProps(){
        if(this.props.PMId !== '' && this.props.isRedirect !== false && this.props.isRedirect !== undefined){
                this.setState({PMId: this.props.PMId, redirect: this.props.isRedirect});
            }
    }

    ViewPMDetails(Id,StatusId){
        if(this.props.ForEquipment !== undefined && this.props.ForEquipment !== null && this.props.ForEquipment)
        {
            this.props.HideButton();
        }
        this.setState({ redirect: true, PMId: Id,statusId: StatusId });
    }

    UpdateRedirection()
    {
        this.setState({ redirect: false});
    }

    onSortNumber = (column) => (e) =>{
        this.setState({ IsDefaultSort: false, IsClosedStatus: false });
        var SortData = this.state.sort.direction;
        var selected = SortData.filter(a => a.name == column);
        const direction = selected[0] ? (selected[0].direction === 'asc' ? 'desc' : 'asc') : 'asc';
        var data_from_state = (this.state.FilterValue !== "7") ? this.props.getPMList.PreventativeMaintenanceList : this.props.getPMList.ClosedPreventativeMaintenaceList;
        if (data_from_state != null) {
            const sortedData = data_from_state.sort((a, b) => {
                let nameA, nameB;
                nameA = a[column];
                nameB = b[column];
                return (nameA - nameB);
            });
            if (direction === 'desc') {
                sortedData.reverse();
            }

            if (selected[0].name == "id") {
                SortData[0].direction = direction;
                const array = this.state.sort.direction;
                array.map(x => (x.name !== "id") ? x.onclick = false : x.onclick = true);
                this.setState({ SortData: array });
            }
            if(this.state.FilterValue !== "7")
                this.props.getPMList.PreventativeMaintenanceList = sortedData;
            else
                this.props.getPMList.ClosedPreventativeMaintenaceList = sortedData;
            this.setState({
                sort: {
                    column,
                    direction: SortData,
                }
            });
            var Data = ({ 'column': column, 'direction': SortData });
            sessionStorage.setItem('PMSortingDetails', JSON.stringify(Data));
            var Data1 = ({ 'filtervalue': this.state.FilterValue, 'isclosedstatus': false });
            sessionStorage.setItem('PMFilterDetails', JSON.stringify(Data1));
        }
    };

    onSort = (column) => (e) =>{
        this.setState({ IsDefaultSort: false, IsClosedStatus: false });
        var SortData = this.state.sort.direction;
        var selected = SortData.filter(a => a.name == column);
        const direction = selected[0] ? (selected[0].direction === 'asc' ? 'desc' : 'asc') : 'asc';
        var data_from_state = (this.state.FilterValue !== "7") ? this.props.getPMList.PreventativeMaintenanceList : this.props.getPMList.ClosedPreventativeMaintenaceList;
        var notequals = 0;          
        if (data_from_state != null) {
            const sortedData = data_from_state.sort((a, b) => {
                let nameA, nameB;
                if(column == "name" || column == "buildingName" || column == "equipmentName"){
                    nameA = a[column].toLowerCase();
                    nameB = b[column].toLowerCase();
                    if(nameA < nameB){
                        notequals = 1;
                        return -1;
                    }
                    if(nameA > nameB){
                        notequals = 1;
                        return 1;
                    }
                    if (nameA == nameB) {
                        return 0;
                    }
                    return 0;
                }
                else{ 
                    if(column == "assignedTo"){
                        var technicianlist = this.props.getTechnicianList;
                        nameA = technicianlist.filter(x => x.technicianID == a[column]).length ?  technicianlist.filter(x => x.technicianID == a[column])[0].name.toLowerCase() : "";
                        nameB = technicianlist.filter(x => x.technicianID == b[column]).length ?  technicianlist.filter(x => x.technicianID == b[column])[0].name.toLowerCase() : "";
                    }
                    else if(column == "status"){
                        nameA = a.status !== 0 ? this.props.getLabels["PreventativeMaintenance.Status."+a.status+".Text"] : "";
                        nameB = b.status !== 0 ? this.props.getLabels["PreventativeMaintenance.Status."+b.status+".Text"] : "";
                    }
                    else{
                        nameA = new Date(a[column]);
                        nameB = new Date(b[column]);
                    }
                    if(nameA < nameB){
                        notequals = 1;
                        return -1;
                    }
                    if(nameA > nameB){
                        notequals = 1;
                        return 1;
                    }
                    if (nameA == nameB) {
                        return 0;
                    }
                    return 0;
                }               
            });
            if (selected[0].direction == 'asc' && notequals == 1) {
                sortedData.reverse();
            }
            if (selected[0].name == "name") {
                SortData[1].direction = direction;
                var array = this.state.sort.direction;
                array.map(x => (x.name !== "name") ? x.onclick = false : x.onclick = true);
                this.setState({ SortData: array });
            }
            if (selected[0].name == "buildingName") {
                SortData[2].direction = direction;
                var array = this.state.sort.direction;
                array.map(x => (x.name !== "buildingName") ? x.onclick = false : x.onclick = true);
                this.setState({ SortData: array });
            }
            if (selected[0].name == "equipmentName") {
                SortData[3].direction = direction;
                var array = this.state.sort.direction;
                array.map(x => (x.name !== "equipmentName") ? x.onclick = false : x.onclick = true);
                this.setState({ SortData: array });
            }
            if (selected[0].name == "dueDate") {
                SortData[4].direction = direction;
                var array = this.state.sort.direction;
                array.map(x => (x.name !== "dueDate") ? x.onclick = false : x.onclick = true);
                this.setState({ SortData: array });
            }
            if (selected[0].name == "assignedTo") {
                SortData[5].direction = direction;
                var array = this.state.sort.direction;
                array.map(x => (x.name !== "assignedTo") ? x.onclick = false : x.onclick = true);
                this.setState({ SortData: array });
            }
            if (selected[0].name == "status") {
                SortData[6].direction = direction;
                var array = this.state.sort.direction;
                array.map(x => (x.name !== "status") ? x.onclick = false : x.onclick = true);
                this.setState({ SortData: array });
            }
            if(this.state.FilterValue !== "7")
                this.props.getPMList.PreventativeMaintenanceList = sortedData;
            else    
                this.props.getPMList.ClosedPreventativeMaintenaceList = sortedData;
            this.setState({
                sort: {
                    column,
                    direction: SortData,
                }
            });
            var Data = ({ 'column': column, 'direction': SortData });
            sessionStorage.setItem('PMSortingDetails', JSON.stringify(Data));
            var Data1 = ({ 'filtervalue': this.state.FilterValue, 'isclosedstatus': false });
            sessionStorage.setItem('PMFilterDetails', JSON.stringify(Data1));
        }
    };

    onSortDate= (column) => (e) =>{
        this.setState({ IsDefaultSort: false, IsClosedStatus: false });
        var SortData = this.state.sort.direction;
        var selected = SortData.filter(a => a.name == column);
        const direction = selected[0] ? (selected[0].direction === 'asc' ? 'desc' : 'asc') : 'asc';
        var data_from_state = (this.state.FilterValue !== "7") ? this.props.getPMList.PreventativeMaintenanceList : this.props.getPMList.ClosedPreventativeMaintenaceList;
        var notequals = 0;
        if (data_from_state != null) {
            var TextRecords = [], NumberRecords = [], DateRecords = [];
            data_from_state.forEach(el => {
                var DueDate = (el.dueDate === "1753-01-01T00:00:00" || el.dueDate == "0001-01-01T00:00:00") ? "---" : el.dueDate;
                if(el.scheduleType === 2){
                    if(el.remainingUsage === null)
                        TextRecords.push(el);
                    else{
                        if(el.remainingUsage === 0)
                            DateRecords.push(el);
                        else
                            NumberRecords.push(el);
                    }
                }else{
                    if(DueDate !== "---")
                        DateRecords.push(el);
                    else
                        TextRecords.push(el);
                }
            });

            const sortedTextData = TextRecords.sort((a, b) => {
                let nameA, nameB;
                nameA = a.scheduleType === 2 ? "NO DATA AVAILABLE" : "---";
                nameB = b.scheduleType === 2 ? "NO DATA AVAILABLE" : "---";
                if(nameA < nameB){
                    notequals = 1;
                    return -1;
                }
                if(nameA > nameB){
                    notequals = 1;
                    return 1;
                }
                if (nameA == nameB) {
                    return 0;
                }
                return 0;
            });
            if (direction == 'desc' && notequals == 1) {
                sortedTextData.reverse();
            }    

            const sortedDateData = DateRecords.sort((a, b) => {
                let nameA, nameB;
                nameA = new Date(a[column]);
                nameB = new Date(b[column]);
                if(nameA < nameB){
                    notequals = 1;
                    return -1;
                }
                if(nameA > nameB){
                    notequals = 1;
                    return 1;
                }
                if (nameA == nameB) {
                    return 0;
                }
                return 0;
            });
            if (direction == 'desc' && notequals == 1) {
                sortedDateData.reverse();
            }

            const sortedNumberData = NumberRecords.sort((a, b) => {
                let nameA, nameB;
                nameA = a['remainingUsage'];
                nameB = b['remainingUsage'];
                return (nameA - nameB);
            });
            if (direction === 'desc') {
                sortedNumberData.reverse();
            }

            let sortedData = [];
            if (direction === 'desc'){
                sortedDateData.map(el => {
                    sortedData.push(el);
                });
                sortedTextData.map(el => {
                    sortedData.push(el);
                });
                sortedNumberData.map(el => {
                    sortedData.push(el);
                });
            }else{
                sortedNumberData.map(el => {
                    sortedData.push(el);
                });
                TextRecords.map(el => {
                    sortedData.push(el);
                });
                sortedDateData.map(el => {
                    sortedData.push(el);
                });
            }

            if (selected[0].name == "dueDate") {
                SortData[4].direction = direction;
                var array = this.state.sort.direction;
                array.map(x => (x.name !== "dueDate") ? x.onclick = false : x.onclick = true);
                this.setState({ SortData: array });
            }
            if(this.state.FilterValue !== "7")
                this.props.getPMList.PreventativeMaintenanceList = sortedData;
            else    
                this.props.getPMList.ClosedPreventativeMaintenaceList = sortedData;
            this.setState({
                sort: {
                    column,
                    direction: SortData,
                }
            });
            var Data = ({ 'column': column, 'direction': SortData });
            sessionStorage.setItem('PMSortingDetails', JSON.stringify(Data));
            var Data1 = ({ 'filtervalue': this.state.FilterValue, 'isclosedstatus': false });
            sessionStorage.setItem('PMFilterDetails', JSON.stringify(Data1));
        }
    };

    getWeek() {
        var l_today = new Date();
        l_today.setHours(0, 0, 0, 0); //discard the time 

        var weekstart = l_today.getDate() - l_today.getDay() + 1;
        var weekend = weekstart + 6;       // end day is the first day + 6 
        var monday = new Date(l_today.setDate(weekstart));
        var sunday = new Date(l_today.setDate(weekend));
        return [monday, sunday];
    };

    searchUpdated(term) {
        this.setState({ searchTerm: this.refs.search_value.value, currentPage: 0 })
        document.getElementsByClassName("PM_header_Check_box")[0].checked = false;
    };

    OnFilterChange(){
        var selectedOption = this.refs.filter_in_Select_input.options.selectedIndex;
        var lFilterId = this.refs.filter_in_Select_input.options[selectedOption].id;
        var lClosedStatus = lFilterId == '7' ? true : false;
        if(lClosedStatus){
            this.props.GetClosedPreventativeMaintenanceList().then(() => {this.setState({ FilterValue: lFilterId, IsClosedStatus: lClosedStatus, currentPage: 0 })});
        }
        else{
            this.setState({ FilterValue: lFilterId, IsClosedStatus: lClosedStatus, currentPage: 0 });
        }
        var Data = ({ 'filtervalue': lFilterId, 'isclosedstatus': lClosedStatus });
        sessionStorage.setItem('PMFilterDetails', JSON.stringify(Data));
        document.getElementsByClassName("PM_header_Check_box")[0].checked = false;
        var checkboxes = document.getElementsByClassName('PreventativeMaintenanceRows');
        for (var i = 0; i < checkboxes.length; i++) {
            checkboxes[i].checked = false;
        }
    };

    handlePageClick = data => {
        let selected = data.selected;
        this.setState({ currentPage: selected });
        var scrollPageTop = (this.props.Premise) ? document.getElementsByClassName('Ensemble_Content_FullPage') : document.getElementsByClassName('Ensemble_Content');
        if(scrollPageTop[0] !== undefined){
            (this.props.Premise) ? scrollPageTop[0].scrollIntoView() : scrollPageTop[0].scrollTop = 0;
        }
        document.getElementsByClassName("PM_header_Check_box")[0].checked = false;
    };

    OpenPrintPreview(){
        var imgURL = document.getElementById('test_trane_logo').src;
        var CurrentDateTime = new Date(); 
        var CurrentTime = CurrentDateTime.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })
        var CurrentDate = (CurrentDateTime.getMonth()+1) + '/' + CurrentDateTime.getDate() + '/' + CurrentDateTime.getFullYear() + ', ' + CurrentTime;
        var selectedOption = this.refs.filter_in_Select_input.options.selectedIndex;
        var lFilterId = this.refs.filter_in_Select_input.options[selectedOption].id;
        var SelectedFilter = this.props.getLabels['WorkOrders.Filter.Options.' + lFilterId + '.Text'];
        var printContent = document.getElementById('divPrintWindow').outerHTML;
        var WindowHeight = ((window.screen.height)-10) + 'px';
        var WindowWidth = ((window.screen.width)-10) + 'px';
        var printWindow = window.open('', 'printwindow', 'height='+WindowHeight+', width='+WindowWidth+', resizable=1, toolbar=no, menubar=no, scrollbars=yes, location=no, directories=no, status=no');
        //create a new HEAD with the exact same content as the main page
        var writeMe = ('<html style="overflow: auto !important;"><body style="overflow: visible !important;"><head>' + document.getElementsByTagName('head')[0].innerHTML + '</head>');

        //grab the content of the printMe div and use it on the print page
        writeMe += ("<div style='display:block !important;' class=\'row row_padding\'><div class='\col-md-12\'>");
        writeMe += ("<br/><label style='vertical-align: bottom !important;margin-bottom: 0.3rem !important;float:left;margin-left:16px;'>Preventative Maintenance </label><label class=\'workOrderlabel'\ style='float:right;margin-right:16px;'>"+CurrentDate+"</label><br/>");
        writeMe += ("<div style='margin:16px'><div style='position: relative;display: -webkit-flex;display: flex;-webkit-flex-wrap: wrap;flex-wrap: wrap;-webkit-align-items: center;align-items: center;-webkit-justify-content: space-between;justify-content: space-between;padding: .5rem 1rem;background: transparent linear-gradient(270deg, #104095 0%, #2070CF 100%) 0% 0% no-repeat padding-box !important; min-height: 54px;-webkit-flex-flow: row nowrap;flex-flow: row nowrap;-webkit-justify-content: flex-start;justify-content: flex-start;'><img id='Trane_Logo' src="+imgURL+"></div></div>");
        writeMe += ("<label style='height: 15px;text-align: left;letter-spacing: 0px;color: #4A4A4A;opacity: 1;font-weight: bold;font-family: lato;font-size: 15px;padding-left: 15px;'>Preventative Maintenance </label><hr style='margin-bottom: 4px;background-color: gray;height: 2px;border: none;margin-top: 4px;margin-left: 15px;margin-right: 15px;'/>");
        writeMe += ("<label style='vertical-align: bottom !important;margin-bottom: 0.3rem !important;padding-left: 16px; padding-bottom: 3px;'>Viewing: "+ SelectedFilter + "</label>");
        writeMe += ("<label style='vertical-align: bottom !important;margin-bottom: 0.3rem !important;float: right; padding-right: 14px;'>"+PrintPaginationText+"</label>");
        writeMe += ("<div id='divPrintPreview'>" + printContent + "</div>");
        writeMe += ("<br/><br/><hr style='margin-bottom: 4px;background-color: gray;height: 2px;border: none;margin-top: 4px;margin-left: 15px;margin-right: 15px;'/><br/>");
        writeMe += ("<label class=\'print_footer'\ style='padding-left: 16px; padding-bottom: 3px;'>Tracer Ensemble<br/>© 2021 Trane Technologies | Privacy Policy | Terms of Use<br/>Page 1 of 1</label>");
        writeMe += ("<div style='float:right'><img id='TraneTech_Logo' style='height: 30px;width: 142px;padding-right: 11px;' src="+TraneTechLogo+" \></div><br/>");
        writeMe += ("<div style='borderTop:1px solid #FFFFFF; padding-bottom: 50px;'/><div style='margin-top:10px; margin-bottom:25px; margin-right:4px'><div style='float:right;'>");
        writeMe += ('<button type=\'button\' class=\'wo_cancel_btn  hide_in_print\' style=\'background: #F1F1F1 0% 0% no-repeat;border: 1px solid #999999;border-radius: 2px;opacity: 1;text-align: center;font-family: Lato;font-size: 12px;letter-spacing: 0.36px;color: #1756B2;width: 80px;height: 30px;float: right; margin-left: 6px; margin-top:3px; margin-right:10px; width:106px\' id=\'btnPrint\' onclick=\'javascript:window.close();\' >' + 'Close Window' + '</button>');
        writeMe += ('<button type=\'button\' class=\'wo_save_btn  hide_in_print\' style=\'background: #2070CF 0% 0% no-repeat;border: 1px solid #999999;border-radius: 2px;opacity: 1;text-align: center;font-family: Lato;font-size: 12px;letter-spacing: 0.36px;color: #FFFFFF;width: 101px;height: 30px;float: right; margin-left: 6px; margin-top:3px\' id=\'btnPrint\' onclick=\'javascript:window.print();\' >' + 'Print' + '</button>');
        writeMe += ("</div></div><br/>");
        writeMe += ('</body></html>');    
        printWindow.document.write(writeMe);
        printWindow.document.close();  
        if (window.focus) {
            printWindow.focus();
        }   
    }

    Deletetoggle() {
        this.setState({
            deletemodal: !this.state.deletemodal
        });
    }

    DeletePM = () => {
        this.setState({ error_msg: false });
        var IsAnyChecked = false;
        var checkboxes = document.getElementsByClassName('PreventativeMaintenanceRows');
        for (var i = 0; i < checkboxes.length; i++) {
            if (checkboxes[i].checked === true) {
                IsAnyChecked = true;
                break;
            }
        }
        if (IsAnyChecked) this.Deletetoggle();
        else this.setState({ error_msg: true });
    }

    Delete = (someArg) => {
        if (someArg == "yes") {
            var Data = [];
            var checkboxes = document.getElementsByClassName('PreventativeMaintenanceRows');
            for (var i = 0; i < checkboxes.length; i++) {
                if (checkboxes[i].checked === true) {
                    Data.push(checkboxes[i].id);
                }
            }
            if(this.props.ForEquipment){
                this.props.DeletePreventativeMaintenance(Data, this.props.EquipmentSummaryId);
            }
            else{
                this.props.DeletePreventativeMaintenance(Data,0);
            }
            document.getElementsByClassName("PM_header_Check_box")[0].checked = false;
        }
        this.Deletetoggle();
    }

    render(getLabels) {
        let lUserCanEdit, IsWorkOrderEditRole, Error_Message = null;
        let PMPreferences = this.props.getPreferences;
        let Filters_in_Select_input;
        let label = this.props.getLabels;
        let PMlist = [], StructuredData = [];
        var data = this.props.getPMList.PreventativeMaintenanceList;
        let UserID = 1;
        let lPMlength = 0, lCurrentPMlength = 0;
        //eslint-disable-next-line
        var Status='',AssignedTo='',Name='',Building='',Equipment='',Schedule='',Description='',EstimateTime='',PartsAndTools='',TaskList='';

        lUserCanEdit = this.props.UserCanEdit;
        IsWorkOrderEditRole = lUserCanEdit !== undefined && lUserCanEdit !== null && lUserCanEdit === 2 ? true : false;
        lUserCanEdit = lUserCanEdit !== undefined && lUserCanEdit !== null && (lUserCanEdit === 3 || lUserCanEdit === 2) ? true : false;
        let lUserCanDelete = this.props.UserCanEdit !== undefined && this.props.UserCanEdit !== null && this.props.UserCanEdit === 3 ? true : false;
        
        if(PMPreferences != undefined && PMPreferences != '')
        {
            Status = PMPreferences.filter(x => x.field === "Status" && x.display === true);
            AssignedTo = PMPreferences.filter(x => x.field === "Assigned To" && x.display === true); 
            Name = PMPreferences.filter(x => x.field === "Name" && x.display === true);
            Building = PMPreferences.filter(x => x.field === "Building" && x.display === true);
            Equipment = PMPreferences.filter(x => x.field === "Equipment" && x.display === true);
            Schedule = PMPreferences.filter(x => x.field === "Schedule" && x.display === true);
            Description = PMPreferences.filter(x => x.field === "Description" && x.display === true);
            EstimateTime = PMPreferences.filter(x => x.field === "Estimated Time" && x.display === true);
            PartsAndTools = PMPreferences.filter(x => x.field === "Parts & Tools" && x.display === true);
            TaskList = PMPreferences.filter(x => x.field === "Task List" && x.display === true);
        }

        var tableColumns = PMPreferences !== undefined && PMPreferences !== "" ? PMPreferences.filter(x => x.display === true).length : "7";
        if (this.props.User_Details !== undefined && this.props.User_Details.user_info !== undefined) {
            UserID = this.props.User_Details.user_info.id;
        }

        if (label['PreventativeMaintenance.Filter.Options.Text'] !== undefined) {
            var Filters = label['PreventativeMaintenance.Filter.Options.Text'].split(',');
            Filters_in_Select_input = Filters.map(el => (
                <option id={el} value={el} >{label['PreventativeMaintenance.Filter.Options.' + el + '.Text']}</option>
            ));
        }

       if(((this.props.getPMList.PreventativeMaintenanceList != null && this.props.getPMList.PreventativeMaintenanceList != undefined && this.props.getPMList.PreventativeMaintenanceList.length > 0) || (this.props.getPMList.ClosedPreventativeMaintenaceList !== null && this.props.getPMList.ClosedPreventativeMaintenaceList !== undefined)) && !this.state.isloading){
        
        if(!this.props.ForEquipment){
            this.props.TriggerPMData(this.props.getPMList.PreventativeMaintenanceList);
            this.props.TriggerPMClosedData(this.props.getPMList.ClosedPreventativeMaintenaceList);
        }

        //Filter functionality
        if(this.state.FilterValue !== "1"){
            if(this.state.FilterValue === "2"){
                data = data.filter(x => x.assignedTo === UserID && x.status !== 6);    
            }
            else if(this.state.FilterValue === "3"){
                data = data.filter(x => x.assignedTo === 0 && x.status !== 6);
            }
            else if(this.state.FilterValue === "4"){
                var date = new Date();
                date.setHours(0, 0, 0, 0);
                data = data.filter(x => new Date(x.dueDate).setHours(0,0,0,0) === Number(date) && x.status !== 6);
            }
            else if(this.state.FilterValue === "5"){
                var date = this.getWeek();
                data = data.filter(x => new Date(x.dueDate).setHours(0, 0, 0, 0) >= Number(date[0]) && new Date(x.dueDate).setHours(0, 0, 0, 0) <= Number(date[1]) && x.status !== 6);
            }
            else if(this.state.FilterValue === "6"){
                var date = new Date();
                var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
                var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
                data = data.filter(x => new Date(x.dueDate).setHours(0, 0, 0, 0) >= Number(firstDay) && new Date(x.dueDate).setHours(0, 0, 0, 0) <= Number(lastDay) && x.status !== 6);           
            }
            else if(this.state.FilterValue === "7"){
                if(this.props.getPMList.ClosedPreventativeMaintenaceList !== null && this.props.getPMList.ClosedPreventativeMaintenaceList !== undefined){
                   // data = this.props.getPMList.ClosedPreventativeMaintenaceList;
                    data = this.props.ForEquipment ? this.props.getPMList.ClosedPreventativeMaintenaceList.filter(x => x.equipmentId === parseInt(this.props.EquipmentSummaryId)) : this.props.getPMList.ClosedPreventativeMaintenaceList;
                }
            }
        }else{
            data = data.filter(x => x.status !== 6);
        }

        if (IsWorkOrderEditRole) {
            data = data.filter(x => x.assignedTo === UserID);
        }

        if(this.state.IsClosedStatus){
            let sortedData = data.sort((a, b) => {
                let nameA, nameB;
                nameA = a["id"];
                nameB = b["id"];
                return (nameA - nameB);
            });
            sortedData.reverse();

            data = sortedData;
            var array = this.state.sort.direction;
                array.map(x => (x.name !== "id") ? x.onclick = false : x.onclick = true);
                array.map(x => x.direction = "desc");
            this.state.sort = { column : 'id', direction: array };
        }

        if (this.state.IsDefaultSort && !this.state.IsClosedStatus) {
            var SortedDetails = sessionStorage.getItem('PMSortingDetails');
            if (SortedDetails !== undefined && SortedDetails !== null && SortedDetails !== "null") {
                var PSortedDetails = JSON.parse(SortedDetails);
                var column = PSortedDetails.column;
                var direction = PSortedDetails.direction.filter(x => x.onclick === true)[0].direction;
                
                if (column === 'id') {
                    let sortedData = data.sort((a, b) => {
                        let nameA, nameB;
                        nameA = a[column];
                        nameB = b[column];
                        return (nameA - nameB);
                    });
                    if (direction === 'desc') {
                        sortedData.reverse();
                    }
                    data = sortedData;
                    this.state.sort = { column, direction: PSortedDetails.direction };
                }
                else if(column === 'dueDate'){
                    const data_from_state = data;
                    var notequals = 0;            //eslint-disable-line
                    if (data_from_state != null) {
                        var TextRecords = [], NumberRecords = [], DateRecords = [];
                        data_from_state.forEach(el => {
                            var DueDate = (el.dueDate === "1753-01-01T00:00:00" || el.dueDate == "0001-01-01T00:00:00") ? "---" : el.dueDate;
                            if (el.scheduleType === 2) {
                                if (el.remainingUsage === null)
                                    TextRecords.push(el);
                                else {
                                    if (el.remainingUsage === 0)
                                        DateRecords.push(el);
                                    else
                                        NumberRecords.push(el);
                                }
                            } else {
                                if (DueDate !== "---")
                                    DateRecords.push(el);
                                else
                                    TextRecords.push(el);
                            }
                        });

                        const sortedTextData = TextRecords.sort((a, b) => {
                            let nameA, nameB;
                            nameA = a.scheduleType === 2 ? "NO DATA AVAILABLE" : "---";
                            nameB = b.scheduleType === 2 ? "NO DATA AVAILABLE" : "---";
                            if(nameA < nameB){
                                notequals = 1;
                                return -1;
                            }
                            if(nameA > nameB){
                                notequals = 1;
                                return 1;
                            }
                            if (nameA == nameB) {
                                return 0;
                            }
                            return 0;
                        });  
                        if (direction == 'desc') {
                            sortedTextData.reverse();
                        }  

                        const sortedDateData = DateRecords.sort((a, b) => {
                            let nameA, nameB;
                            nameA = new Date(a['dueDate']);
                            nameB = new Date(b['dueDate']);
                            if (nameA < nameB) {
                                notequals = 1;
                                return -1;
                            }
                            if (nameA > nameB) {
                                notequals = 1;
                                return 1;
                            }
                            if (nameA == nameB) {
                                return 0;
                            }
                            return 0;
                        });
                        if (direction === 'desc') {
                            sortedDateData.reverse();
                        }

                        const sortedNumberData = NumberRecords.sort((a, b) => {
                            let nameA, nameB;
                            nameA = a['remainingUsage'];
                            nameB = b['remainingUsage'];
                            return (nameA - nameB);
                        });
                        if (direction === 'desc') {
                            sortedNumberData.reverse();
                        }

                        data = [];
                        if (direction === 'desc') {
                            sortedDateData.map(el => {
                                data.push(el);
                            });
                            sortedTextData.map(el => {
                                data.push(el);
                            });
                            sortedNumberData.map(el => {
                                data.push(el);
                            });
                        }else{
                            sortedNumberData.map(el => {
                                data.push(el);
                            });
                            TextRecords.map(el => {
                                data.push(el);
                            });
                            sortedDateData.map(el => {
                                data.push(el);
                            });
                        }
                        
                    }
                    this.state.sort = { column, direction: PSortedDetails.direction };
                }
                else{
                    let sortedData = data.sort((a, b) => {
                    let nameA, nameB;
                    if(column == "name" || column == "buildingName" || column == "equipmentName"){
                        nameA = a[column].toLowerCase();
                        nameB = b[column].toLowerCase();
                    }
                    else{ 
                        if(column == "assignedTo"){
                            var technicianlist = this.props.getTechnicianList;
                            nameA = technicianlist.filter(x => x.technicianID == a[column]).length ?  technicianlist.filter(x => x.technicianID == a[column])[0].name.toLowerCase() : "";
                            nameB = technicianlist.filter(x => x.technicianID == b[column]).length ?  technicianlist.filter(x => x.technicianID == b[column])[0].name.toLowerCase() : "";
                        }
                        else if(column == "status"){
                            nameA = a.status !== 0 ? this.props.getLabels["PreventativeMaintenance.Status."+a.status+".Text"] : "";
                            nameB = b.status !== 0 ? this.props.getLabels["PreventativeMaintenance.Status."+b.status+".Text"] : "";
                        }
                        else{
                            nameA = new Date(a[column]);
                            nameB = new Date(b[column]);
                        }
                     }
                        if(nameA < nameB){
                            return -1;
                        }
                        if(nameA > nameB){
                            return 1;
                        }
                        if (nameA == nameB) {
                            return 0;
                        }
                        return 0;
                    });
                if (direction == 'desc') {
                    sortedData.reverse();
                }
                data = sortedData;
                this.state.sort = { column, direction: PSortedDetails.direction };
            }
        }
        else{
            const data_from_state = data;
            var notequals = 0;
            if (data_from_state != null) {
                var TextRecords = [], NumberRecords = [], DateRecords = [];
                data_from_state.forEach(el => {
                var DueDate = (el.dueDate === "1753-01-01T00:00:00" || el.dueDate == "0001-01-01T00:00:00") ? "---" : el.dueDate;
                if(el.scheduleType === 2){
                    if(el.remainingUsage === null)
                        TextRecords.push(el);
                    else{
                        if(el.remainingUsage === 0)
                            DateRecords.push(el);
                        else
                            NumberRecords.push(el);
                    }
                }else{
                    if(DueDate !== "---")
                        DateRecords.push(el);
                    else
                        TextRecords.push(el);
                }
            });

            const sortedDateData = DateRecords.sort((a, b) => {
                let nameA, nameB;
                nameA = new Date(a['dueDate']);
                nameB = new Date(b['dueDate']);
                if(nameA < nameB){
                    notequals = 1;
                    return -1;
                }
                if(nameA > nameB){
                    notequals = 1;
                    return 1;
                }
                if (nameA == nameB) {
                    return 0;
                }
                return 0;
            });
            sortedDateData.reverse();

            const sortedNumberData = NumberRecords.sort((a, b) => {
                let nameA, nameB;
                nameA = a['remainingUsage'];
                nameB = b['remainingUsage'];
                return (nameA - nameB);
            });
            sortedNumberData.reverse();
            
            data = [];
            sortedDateData.map(el => {
                data.push(el);
            });
            TextRecords.map(el => {
                data.push(el);
            });
            sortedNumberData.map(el => {
                data.push(el);
            });
            }
        }
    }

        data.forEach(el => {

            var l_EquipmentName = el.equipmentName != "" ? el.equipmentName : '---';

            var lineitem = {
                "id": el.id,
                "serialNumber": el.serialNumber,
                "title": el.name !== "" ? el.name : <b>---</b>,
                "buildingName": el.buildingId !== 0 && el.buildingName !== "" ? el.buildingName : <b>---</b>,
                "equipment": el.equipmentId !== 0 ? l_EquipmentName : <b>---</b>,
                "due" :(el.dueDate === '1753-01-01T00:00:00' || el.dueDate === '0001-01-01T00:00:00') ? <b>---</b> : new Intl.DateTimeFormat('en-US', { year: 'numeric', month: 'short', day: 'numeric' }).format(new Date(el.dueDate)), 
                "technicianName": (el.assignedTo !== 0 && el.assignedToName !== "" ? el.assignedToName : <b>---</b>),
                "status": el.status,
                "statusName": (el.status > 0) ? (Status.length > 0 ? Status[0].value.filter(x => x.key == el.status)[0] !== undefined ? Status[0].value.filter(x => x.key == el.status)[0].value : "" : "---") : <b>---</b>,
                "scheduleType": el.scheduleType,
                "remainingUsage": el.remainingUsage,
                "isDueDatePassed": el.isDueDatePassed,
                "dueDate":el.dueDate,
                
            }
            StructuredData.push(lineitem);
        });
    
        let FilteredData = StructuredData.filter(createFilter(this.state.searchTerm, KEYS_TO_FILTERS));
        lPMlength = FilteredData.length;
        //Reset header checkbox based on row checkbox 
        // if(document.querySelectorAll('input[type="checkbox"]').length && document.querySelectorAll('input.PreventativeMaintenanceRows').length){
        //     if((document.querySelectorAll('input.PreventativeMaintenanceRows:checked').length !== lPMlength)||(document.querySelectorAll('input.PreventativeMaintenanceRows:checked').length === 0))
        //         document.getElementsByClassName("PM_header_Check_box")[0].checked = false;
        //     else
        //         document.getElementsByClassName("PM_header_Check_box")[0].checked = true;
        // }
        pagesCount = Math.ceil(FilteredData.length / this.state.pageSize);
        PMlist = FilteredData.length ? FilteredData.slice(this.state.currentPage * this.state.pageSize, (this.state.currentPage + 1) * this.state.pageSize).map(el=> (
            <tr key={el.id}>
                <td><input type="checkbox" id={el.id} className="PreventativeMaintenanceRows" onClick={() => { SelectAllCheckboxes.ResetHeaderCheckBox("PreventativeMaintenanceRows", "PM_header_Check_box"); }} /></td>
                <td>
                    {
                    lUserCanEdit ? <p className="link_cursor" style={{ color: '#6890C6' }} onClick={() => { this.ViewPMDetails(el.id,el.status) }} >{el.serialNumber}</p> : <p className="link_cursor">{el.serialNumber}</p>
                    }
                </td>
                {Name.length > 0 ? <td>{el.title}</td> : ''}
                {Building.length > 0 ? <td>{el.buildingName}</td> : ''}
                {Equipment.length > 0 ? <td>{el.equipment}</td> : ''}
                {el.scheduleType === 2 ? 
                    el.remainingUsage === null 
					? <td><b>NO DATA AVAILABLE</b></td> : el.remainingUsage === 0 
					? (el.isDueDatePassed === true && el.status !== 6 && (el.dueDate !== '1753-01-01T00:00:00' && el.dueDate !== '0001-01-01T00:00:00')) ?
						<td>{el.due} <Icon name='exclamation triangle' style={{ 'color': 'red', 'padding-left': '8px', 'padding-right': '14px', 'padding-top': '0px' }} /> <Label style={{ 'color': 'red' }} >Past Due</Label> </td>
						:<td>{el.due}</td> 
					:
                    <td><i>{el.remainingUsage + "% usage remaining"}</i><br/><ProgressBar className="progressbar-border" now={100-el.remainingUsage} /></td> 
                : (el.isDueDatePassed === true && el.status !== 6 && (el.dueDate !== '1753-01-01T00:00:00' && el.dueDate !== '0001-01-01T00:00:00')) ?
					<td>{el.due} <Icon name='exclamation triangle' style={{ 'color': 'red', 'padding-left': '8px', 'padding-right': '14px', 'padding-top': '0px' }} /> <Label style={{ 'color': 'red' }} >Past Due</Label> </td>
					:<td>{el.due}</td>}
                {AssignedTo.length > 0 ? <td>{el.technicianName}</td> : ''}
                {Status.length > 0 ? <td>{el.statusName}</td> : ''}
            </tr>
        )) : <tr><td colSpan={tableColumns}>{label['WorkOrders.Table.Default.Text']}</td></tr>;
        
        if(PMlist.length !== undefined)
            lCurrentPMlength = PMlist.length;
    }else if(!this.state.isloading){
        PMlist = <tr><td colSpan={tableColumns}>{label['WorkOrders.Table.Default.Text']}</td></tr>  
    }else{
        PMlist = <tr><td colSpan={tableColumns} style={{textAlign: 'center'}}><LoadingIndicator/></td></tr>  
    } 

    let PMListTable = <div className="table_container table_border" id="divPrintWindow" style={{'margin-bottom':'0px','margin-left':'15px','margin-right':'15px'}}>
    <Table striped responsive className="Custom_table" >
        <tbody className="cell_container">
            <tr>
                <th width="5%"><input type="checkbox"  className="PM_header_Check_box" onClick={() => { SelectAllCheckboxes.selectAllCheckbox("PreventativeMaintenanceRows", "PM_header_Check_box"); }} /></th>
                <th className="link_cursor" onClick={this.onSortNumber('id')}>
                <span>{label !== undefined && label['PreventativeMaintenance.Columns.Record.Text'] !== undefined ? label['PreventativeMaintenance.Columns.Record.Text'] : "Record#"}</span>
                    <span className={(this.state.sort.direction[0].name == "id") ?
                                    (this.state.sort.direction[0].onclick) ? (this.state.sort.direction[0].direction == "asc") ? "workorder-sort-direction asccolor printstlye" : "workorder-sort-direction desccolor printstlye"
                                    : (this.state.sort.direction[0].direction == "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc printstlye" : "workorder-sort-direction desc printstlye"}>
                </span>
                </th>
                {Name.length > 0 ?
                <th className="link_cursor" onClick={this.onSort('name')}>{Name[0].fieldLabel}
                    <span className={(this.state.sort.direction[1].name == "name") ?
                                    (this.state.sort.direction[1].onclick) ? (this.state.sort.direction[1].direction == "asc") ? "workorder-sort-direction asccolor printstlye" : "workorder-sort-direction desccolor printstlye"
                                    : (this.state.sort.direction[1].direction == "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc printstlye" : "workorder-sort-direction desc printstlye"}>
                    </span>
                </th> : ""
                }
                {Building.length > 0 ?
                <th className="link_cursor" onClick={this.onSort('buildingName')}>{Building[0].fieldLabel}
                    <span className={(this.state.sort.direction[2].name == "buildingName") ?
                                    (this.state.sort.direction[2].onclick) ? (this.state.sort.direction[2].direction == "asc") ? "workorder-sort-direction asccolor printstlye" : "workorder-sort-direction desccolor printstlye"
                                    : (this.state.sort.direction[2].direction == "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc printstlye" : "workorder-sort-direction desc printstlye"}>
                    </span>
                </th> : ""
                }
                {Equipment.length > 0 ?
                <th className="link_cursor" onClick={this.onSort('equipmentName')}>{Equipment[0].fieldLabel}
                    <span className={(this.state.sort.direction[3].name == "equipmentName") ?
                                    (this.state.sort.direction[3].onclick) ? (this.state.sort.direction[3].direction == "asc") ? "workorder-sort-direction asccolor printstlye" : "workorder-sort-direction desccolor printstlye"
                                    : (this.state.sort.direction[3].direction == "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc printstlye" : "workorder-sort-direction desc printstlye"}>
                    </span>
                </th> : ""
                }
                <th className="link_cursor" onClick={this.onSortDate('dueDate')}>Due
                    <span className={(this.state.sort.direction[4].name == "dueDate") ?
                                    (this.state.sort.direction[4].onclick) ? (this.state.sort.direction[4].direction == "asc") ? "workorder-sort-direction asccolor printstlye" : "workorder-sort-direction desccolor printstlye"
                                    : (this.state.sort.direction[4].direction == "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc printstlye" : "workorder-sort-direction desc printstlye"}>
                    </span>
                </th>
                {AssignedTo.length > 0 ?
                <th className="link_cursor" onClick={this.onSort('assignedTo')}>{AssignedTo[0].fieldLabel}
                    <span className={(this.state.sort.direction[5].name == "assignedTo") ?
                                    (this.state.sort.direction[5].onclick) ? (this.state.sort.direction[5].direction == "asc") ? "workorder-sort-direction asccolor printstlye" : "workorder-sort-direction desccolor printstlye"
                                    : (this.state.sort.direction[5].direction == "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc printstlye" : "workorder-sort-direction desc printstlye"}>
                    </span>
                </th> : ""
                }
                {Status.length > 0 ?
                <th className="link_cursor" onClick={this.onSort('status')}>{Status[0].fieldLabel}
                    <span className={(this.state.sort.direction[6].name == "status") ?
                                    (this.state.sort.direction[6].onclick) ? (this.state.sort.direction[6].direction == "asc") ? "workorder-sort-direction asccolor printstlye" : "workorder-sort-direction desccolor printstlye"
                                    : (this.state.sort.direction[6].direction == "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc printstlye" : "workorder-sort-direction desc printstlye"}>
                    </span>
                </th> : ""
                }
            </tr>
            {PMlist}
        </tbody>
    </Table>
</div>
 PrintPaginationText = (lPMlength !== 0 ? this.state.currentPage*50+1 : 0) + "-" + ((this.state.currentPage*50)+lCurrentPMlength) + " of " + lPMlength + " records";
 (this.state.error_msg == true) ? Error_Message = <p className="error_msg"> <img src={ErrorGif} alt="Trane Logo" />  {ErrorMessage.selection_error_pm}</p> : Error_Message = "";
        return (
            <div className={this.props.Premise ? (this.props.ForEquipment ? "main_container workOrderContainer": "main_container") : this.props.ForEquipment ? "cloud_main_container workOrderContainer": "cloud_main_container"}>
                <div className={this.props.ForEquipment ? "" : "border_container"}>
                {
                    this.props.ForEquipment ? "" : String.fromCharCode(160)
                }
                {
            this.state.redirect ? <PMDetails PMId={this.state.PMId} StatusId={this.state.statusId} ForEquipment={this.props.ForEquipment} Premise={this.props.Premise} UpdateRedirection={this.UpdateRedirection} ShowCreateButton={this.props.ShowCreateButton} /> :
            <div className={this.props.ForEquipment ? "main_container workOrderContainer": "main_container"}> 
                <div className="row row_padding" style={{'margin-left':'0px','margin-right':'0px','margin-bottom':'24px'}}>
                    <div className="col-md-6">
                        {Error_Message}
                    </div>
                    <div className="col-md-6" style={{'display':this.props.ForEquipment ?'none':'block'}}>
                        <FaPrint className="icons-Menu-print" onClick={this.OpenPrintPreview} />
                    </div>
                </div>
            <div className="row row_padding" style={{'margin-left':'0px','margin-right':'0px'}}>
                <div className="col-md-6">
                    <label className={this.props.ForEquipment ? "workOrderlabel" : ""} style={{ fontFamily: 'lato', fontSize: '13px', fontWeight:'bold', color:'black'}}>{label !== undefined ? label['PreventativeMaintenance.Filter.Viewing.Text'] : "Viewing:"}</label>
                    <select ref='filter_in_Select_input' style={{ "margin-left": "10px", "margin-top": "10px" }} className="pmminimal pm-dropdown" placeholder={label['PreventativeMaintenance.DropDown.Default.Text']} onChange={this.OnFilterChange} value={this.state.FilterValue}>
                        {Filters_in_Select_input}
                    </select>
                </div>
                <div className="col-md-6" style={{paddingTop:'11px'}}>
                    <label style={{ fontFamily: 'lato', fontSize: '13px', fontWeight: 'bold', color: 'black', marginLeft: '26px', float: 'right', 'margin-top': '4px' }}>{(lPMlength !== 0 ? this.state.currentPage*50+1 : 0) + "-" + ((this.state.currentPage*50)+lCurrentPMlength) + " of " + lPMlength + " records"}</label>
                    { lUserCanDelete ? <Button className="child_tab_button" onClick={() => this.DeletePM()}>{label['WorkOrders.DeleteTenant.Text'] !== undefined ? label['WorkOrders.DeleteTenant.Text'] : "DELETE"}</Button> : "" }
                    <span className="pm_outersearchbox" style={{ float: 'right' }}>
                        <input type="text" className="pm_searchbox" style={{ paddingLeft: '10px', 'margin-top': '3px' }} placeholder="Enter Value..." onChange={this.searchUpdated} ref='search_value' />
                    </span>
                    <label style={{ fontFamily: 'lato', fontSize: '13px', fontWeight: 'bold', color: 'black', float: 'right', 'margin-top': '4px' }}>{label !== undefined ? label['PreventativeMaintenance.Search.Text'] : "Search:"}</label>
                </div>
            </div>
            <br/>
            {PMListTable}
            <div className="row row_padding pm_pagination" style={{'margin-right':'15px'}}>
                <div className="col-md-7">
                    <ReactPaginate
                        previousLabel={'Prev'}
                        nextLabel={'Next'}
                        breakLabel={'...'}
                        breakClassName={'break-me pagination_margin'}
                        breakLinkClassName={'pagination_link_color'}
                        pageCount={pagesCount}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={10}
                        onPageChange={this.handlePageClick}
                        containerClassName={'pagination pagination_container_margin'}
                        subContainerClassName={'pages pagination'}
                        activeClassName={'active'}
                        disabledClassName={'pagination_disable_link'}
                        pageClassName={'pagination_margin'}
                        pageLinkClassName={'pagination_link_color'}
                        previousClassName={'pagination_margin'}
                        previousLinkClassName={'pagination_link_color'}
                        nextClassName={'pagination_margin'}
                        nextLinkClassName={'pagination_link_color'}
                        forcePage={this.state.currentPage}
                    />
                </div>
                <Modal isOpen={this.state.deletemodal} deletemodal={this.deletemodal} className={classnames({ classnames: this.props.className }, "ModalContainer short_modal")} >
                    <DeleteConfirmation parentToChildData={["Delete Preventative Maintenance", "You are about to delete a preventative maintenance from the system. Do you want to continue?", "Close Window", "Delete Preventative Maintenance"]} Delete={this.Delete} />
                </Modal>
            </div>
        </div>
                }
                </div>
                <div><img id="test_trane_logo" alt="Trane" src={TraneLogo} style={{"display":"none"}}/></div>
            </div>
        );

    }
};

const mapStateToProps = state => {
    return {
        getLabels: state.CulturalLabelsRootReducer.WorkOrderResource_LabelsBasedOnPreference,
        getPMList: state.WorkorderRootReducer,
        getTechnicianList: state.WorkorderRootReducer.Technicians,
        getBuildingEquipments: state.WorkorderRootReducer.BuildingsEquipments,
        User_Details: state.userDetailsRootReducer,
        getPreferences: state.authService.preventative_maintenance_user_preferencedetails,
        UserCanEdit: state.authService.HasWorkOrderAccess,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        GetPreventativeMaintenanceList: () => dispatch(GetPreventativeMaintenanceList()),
        GetClosedPreventativeMaintenanceList: () => dispatch(GetClosedPreventativeMaintenanceList()),
        GetEquipmentPreventativeMaintenanceList: (Id) => dispatch(GetEquipmentPreventativeMaintenanceList(Id)),
        DeletePreventativeMaintenance: (id, equipmentID) => dispatch(DeletePreventativeMaintenance(id, equipmentID)),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(PreventativeMaintenanceList);